// app/javascript/modules/pane_manager.js
class PaneFactory {
  constructor(panePath, turboFramePrefix) {
    this.panePath = panePath;
    this.turboFramePrefix = turboFramePrefix;
  }

  // FIXME: Probably a better idea to keep this in the app/views as a partial instead of creating the html on the fly here.
  create(slug, href) {
    const frame = document.createElement("turbo-frame");
    frame.id = `${this.turboFramePrefix}${slug}`;
    frame.src = href || `${this.panePath}/${slug}`;
    frame.classList.add("pane");
    frame.dataset.paneStackTarget = "pane";
    frame.dataset.slug = slug;
    return frame;
  }
}

class PaneStackInterface {
  getPanes(container) { throw new Error("Not implemented"); }
  getSlugs(container) { throw new Error("Not implemented"); }
  findBySlug(slug, container) { throw new Error("Not implemented"); }
  removeAfter(pane, container) { throw new Error("Not implemented"); }
}

class PaneStack extends PaneStackInterface {
  getPanes(container) {
    return Array.from(container.querySelectorAll('[data-pane-stack-target="pane"]'));
  }

  getSlugs(container) {
    return this.getPanes(container).map(pane => pane.dataset.slug).filter(Boolean);
  }

  findBySlug(slug, container) {
    return this.getPanes(container).find(pane => pane.dataset.slug === slug);
  }

  removeAfter(pane, container) {
    let next = pane.nextElementSibling;
    while (next) {
      const temp = next.nextElementSibling;
      next.remove();
      next = temp;
    }
  }
}

// Main PaneManager class with bound container
export class PaneManager {
  constructor(panePath, turboFramePrefix, container) {
    this.panePath = panePath;
    this.turboFramePrefix = turboFramePrefix;
    this.container = container;
    this.paneFactory = new PaneFactory(panePath, turboFramePrefix);
    this.paneStack = new PaneStack();
  }

  openPane(slug, href, currentPane) {
    if (currentPane) this.paneStack.removeAfter(currentPane, this.container);
    this.appendPane(slug, href);
    return this.paneStack.getSlugs(this.container);
  }

  appendPane(slug, href) {
    const existingPane = this.paneStack.findBySlug(slug, this.container);
    if (existingPane) existingPane.remove();
    const pane = this.paneFactory.create(slug, href);
    this.container.appendChild(pane);
  }

  closePane(pane, container) {
    if (pane) {
      pane.remove();
      return this.paneStack.getSlugs(container);
    }
    return [];
  }

  findPaneBySlug(slug, container) {
    return this.paneStack.findBySlug(slug, container);
  }

  clearPanes(except = []) {
    this.paneStack.getPanes(this.container)
      .filter(pane => !except.includes(pane.id))
      .forEach(pane => pane.remove());
  }
}
